module.exports = __webpack_public_path__ + "img/olc-screen-olc-7.2e986f65.jpg";